import React from 'react'
import Header from '../Header'
import Footer from '../Footer'
import BeachFooter from '../Footer/beachFooter'

const Layout = ({ props, children, ...rest }) => {
    const checkBeachThemeClassName = document.body.className == 'liquidationTwo beachLiquidation'
    const isPrimeBids = global.storeConfigration?.bodyClass?.value == 'primeBids'
    return (
        <div className="app-wrapper">
            {/* <h1>Hi {currentUser.name}!</h1> */}
            {isPrimeBids ? (
                <div className="primeClosed">
                    <div className="textClosed d-flex flex-column justify-content-center">
                        <img src="/assets/svg/closed-icon.svg" />
                        <h2>
                            <b>PrimeBids</b> warehouse is now permanently closed.
                            <br /> If you have any uncollected items, please ensure they are picked
                            up by <b>December 12, 2025</b>.<br /> We sincerely appreciate your
                            continued support.
                        </h2>
                    </div>
                </div>
            ) : (
                <>
                    <Header />
                    <div className="main-container">{children}</div>
                    {checkBeachThemeClassName ? <BeachFooter /> : <Footer />}
                </>
            )}
        </div>
    )
}

export default Layout
